import { atom } from "recoil";

export const globalParamsState = atom<{ [key: string]: string }>({
  default: {},
  key: "global-params",
});
